module.exports = __webpack_public_path__ + "static/logo2-d9e60c2ca51c834505ce75b42efc7232.png";